module.exports = __webpack_public_path__ + "static/logo-blk.96fbacce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-blk.png
// module id = 214
// module chunks = 7203239478734 27447698812214 34471704633725 114276838955818 173894859265406